// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ls-machine-item{min-height:11rem}.ls-machine-item .menu{top:1rem;right:1rem;z-index:1}", ""]);
// Exports
module.exports = exports;
